import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router";

//
import MainLayout from "../layout/MainLayout.js";
import Main from "../pages/main/Main";
import AboutClinic from "../pages/aboutClinic/AboutClinic.js";
import Contact from "../pages/contact/Contact.js";
import Doctor from "../pages/doctor/Doctor.js";
import DoctorSingle from "../pages/doctor/DoctorSingle.js";
import EyeDisease from "../pages/eyeDisease/EyeDisease.js";
import EyeDiseaseSingle from "../pages/eyeDisease/EyeDiseaseSingle.js";
import Faq from "../pages/faq/Faq.js";
import Review from "../pages/review/Review.js";
import AllService from "../pages/service/AllService.js";
import SingleService from "../pages/service/SingleService.js";

export default function Router() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Main />} />
        <Route path="about">
          <Route index element={<h1>About</h1>} />
          <Route path="clinic" element={<AboutClinic />} />
          <Route path="doctor" element={<Doctor />} />
          <Route path="doctor/:id" element={<DoctorSingle />} />
          <Route path="eye-disease" element={<EyeDisease />} />
          <Route path="eye-disease/:id" element={<EyeDiseaseSingle />} />
          <Route path="review" element={<Review />} />
          <Route path="faq" element={<Faq />} />
        </Route>
        <Route path="service">
          <Route index element={<h1>Service</h1>} />
          <Route path="all" element={<AllService />} />
          <Route path=":id" element={<SingleService />} />
        </Route>
        <Route path="contact">
          <Route index element={<Contact />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
